<template>
    <div>
        <div class="form-group">
            <label class="col-md-2 control-label">Length in Meters</label>
            <div class="col-md-2">
                <input type="number" class="form-control" min="0" step="0.01" v-model="propertyDescription.length">
            </div>
            <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'length'" :hasAppend="false"></qaqcFormFieldSelect>
        </div>
        <div class="form-group">
            <label class="col-md-2 control-label">Width in Meters</label>
            <div class="col-md-2">
                <input type="number" class="form-control" min="0" step="0.01" v-model="propertyDescription.width">
            </div>
            <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'width'" :hasAppend="false"></qaqcFormFieldSelect>
        </div>
        <div class="form-group">
            <label class="col-md-2 control-label">Area in Square Meters</label>
            <div class="col-md-2">
                <input type="number" class="form-control" min="0" step="0.01" v-model="propertyDescription.area">
            </div>
            <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'area'" :hasAppend="false"></qaqcFormFieldSelect>
        </div>
        <div class="form-group">
            <label class="col-md-2 control-label">Boundary estimates based on</label>
            <div class="col-md-10">
                <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'propertyBoundaryList'" :hasAppend="true"></qaqcFormFieldSelect>
                <checkBoxPanel :numColumns="3" :lookupList="boundaryTypeList" ref="boundaryCheckboxPanel" :fieldName="'boundaryTypeId'" :name="qaqcFieldId + 'propertyDescBoundaryCB'" />
            </div>
        </div>
        <div v-if="!(qaqcEnabled || formDisabled)" class="form-group">
            <div class="col-md-2">
                <button class="btn btn-primary pull-right" v-on:click="savePropertyDescription">Save</button>
            </div>
        </div>
        <qaqcFormFieldFooter v-if="qaqcEnabled" :qaqcProgressDto="qaqcProgressDto" :qaqcSelection="qaqcSelection" :sectionName="'propertyDescription'" :completeSection="completeSection"></qaqcFormFieldFooter>
    </div>
</template>

<script>
import loggingService from '../../services/util/loggingService'
import propertyDescriptionService from '../../services/siteForm/propertyDescriptionService'
import loader from '../Loader.vue'
import checkBoxPanel from '../CheckBoxPanel.vue'
import qaqcFormFieldSelect from '@/components/SiteForm/QaqcFormFieldSelect.vue'
import qaqcFormFieldFooter from '@/components/SiteForm/QaqcFormFieldFooter.vue'

export default {
    name: 'propertyDescriptionForm',
    components: {
        loader,
        checkBoxPanel,
        qaqcFormFieldSelect,
        qaqcFormFieldFooter
    },
    props: {
        formDisabled: { default: false },
        qaqcEnabled: { default: false },
        qaqcProgressDto: { default: () => {} },
        saveQaqcProgress: { default: null },
        crrId: { default: null }
    },
    data: function () {
        return {
            isDebug: false,
            isLoading: false,
            boundaryTypeList: [],
            propertyDescription: {}
        }
    },
    computed: {
        qaqcSelection: function () {
            if (this.qaqcProgressDto && this.qaqcProgressDto.qaqcSelections) {
                // // if there's no propertyDescription qa/qc object, create new instance
                // if (!this.qaqcProgressDto.qaqcSelections.propertyDescription) {
                //     this.qaqcProgressDto.qaqcSelections.propertyDescription = qaqcService.qaqcSelections().propertyDescription
                // }
                return this.qaqcProgressDto.qaqcSelections.propertyDescription
            } else {
                return {}
            }
        },
        qaqcFieldId: function () {
            return this.qaqcEnabled ? 'qaqc' : ''
        }
    },
    watch: {
        crrId: function (val) {
            this.log('crrId is changed: ' + val)
            this.loadData().then(result => {
                this.loadLookups()
                this.isLoading = false
            })
        }
    },
    mounted () {
        this.isLoading = true
        if (this.crrId) {
            this.loadData().then(result => {
                this.loadLookups()
                this.isLoading = false
            })
        }
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'InvestigativeHistoryForm', message)
        },
        loadPropertyBoundaries () {
            this.log('load property boundary')
            var searchDto = {propertyDescriptionId: this.propertyDescription.propertyDescriptionId}
            return propertyDescriptionService.searchPropertyBoundary(this.$http, searchDto).then(result => {
                this.$refs.boundaryCheckboxPanel.selectedList = result.data.map(x => {
                    return x.boundaryTypeId
                })
                return result
            })
        },
        createNewInstance () {
            this.propertyDescription = {
                culturalResourceRecordingId: this.crrId
            }
        },
        loadData () {
            var crrId = this.crrId
            this.log('Loading Data for crrId: ' + crrId)
            //return Promise.resolve(1)
            return propertyDescriptionService.searchPropertyDescription(this.$http, {culturalResourceRecordingId: crrId}).then(response => {
                if (response.data.length > 0) {
                    this.log('found one response')
                    this.propertyDescription = response.data[0]
                    Promise.all([
                        this.loadPropertyBoundaries()
                    ]).then(response2 => {
                        this.log('done loading others')
                        return response2
                    })
                } else {
                    this.log('creating new instance')
                    return this.createNewInstance()
                }
            })
        },
        loadLookups () {
            this.boundaryTypeList = propertyDescriptionService.getBoundaryTypeList()
        },
        savePropertyDescription () {
            this.propertyDescription.propertyBoundaryList = this.$refs.boundaryCheckboxPanel.selectedList.map(x => {
                return {
                    propertyDescriptionId: this.propertyDescription.propertyDescriptionId,
                    boundaryTypeId: x
                }
            })
            propertyDescriptionService.putPropertyDescription(this.$http, this.propertyDescription).then(result => {
                this.propertyDescription = result.data.objectList[0]
                this.loadData().then(result3 => {
                    this.log('save complete')
                })
            })
        },
        completeSection () {
            // check if all selections have been made
            if (Object.values(this.qaqcSelection).includes(0)) {
                alert('Please complete all QA/QC selections in this section.')
                return
            }
            this.savePropertyDescription()
            this.saveQaqcProgress('propertyDescription', true)
        }
    }
}
</script>



// WEBPACK FOOTER //
// PropertyDescriptionForm.vue?5c5ba4ed